import { getM8AuthURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

export const getEnvironmentServer = async (): Promise<string> => {
  const response = await fetch(getM8AuthURL('getEnvironmentServer'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  const text = response.text();

  return text;
};
